import Spanish from './lang.es.json';

export const Messages = { ...Spanish };
